(function () {
  'use strict';
  var cleanups = new WeakMap();
  function nodes(selector, root) {
    var result = Array.from(root.querySelectorAll(selector));
    if (root.matches && root.matches(selector)) result.unshift(root);
    return result;
  }
  function money(cents, node) {
    return new Intl.NumberFormat(node.dataset.locale || document.documentElement.lang || 'en', {
      style: 'currency', currency: node.dataset.currency || 'USD'
    }).format(cents / 100);
  }
  function bind(node, setup) {
    if (cleanups.has(node)) cleanups.get(node)();
    var controller = new AbortController();
    var on = function (target, event, callback) { target.addEventListener(event, callback, { signal: controller.signal }); };
    setup(on);
    cleanups.set(node, function () { controller.abort(); });
  }
  function updateBulk(node, unitCents, quantity, valid) {
    var enabled = node.dataset.bulkEnabled === 'true';
    var tier = quantity >= 10 ? 10 : quantity >= 5 ? 5 : quantity >= 3 ? 3 : quantity >= 2 ? 2 : 0;
    var rate = enabled && tier ? Number(node.getAttribute('data-bulk-discount-' + tier)) : 0;
    var estimate = node.querySelector('[data-bulk-estimate]');
    node.querySelectorAll('[data-bulk-tier]').forEach(function (item) {
      item.toggleAttribute('data-active', enabled && valid && Number(item.dataset.bulkTier) === tier);
    });
    if (!estimate) return;
    estimate.hidden = !valid || !enabled || !Number.isFinite(rate) || rate <= 0 || rate > 100;
    if (estimate.hidden) return;
    var base = unitCents * quantity;
    var saving = Math.round(base * rate / 100);
    var after = base - saving;
    estimate.querySelector('[data-bulk-percent]').textContent = '(' + rate + '%)';
    estimate.querySelector('[data-bulk-savings]').textContent = money(saving, node);
    estimate.querySelector('[data-bulk-total]').textContent = money(after, node);
    estimate.querySelector('[data-bulk-unit]').textContent = money(Math.round(after / quantity), node);
  }
  function init(root) {
    nodes('[data-product-section]', root).forEach(function (section) {
      bind(section, function (on) {
        var select = section.querySelector('[data-variant-select]');
        var quantity = section.querySelector('[data-order-quantity]');
        var output = section.querySelector('[data-order-subtotal]');
        var pills = section.querySelector('[data-quick-sizes]');
        function revealGuide() {
          if (window.location.hash !== '#ArtworkRequirements') return;
          var guide = section.querySelector('#ArtworkRequirements');
          if (guide) { guide.open = true; guide.scrollIntoView({ block: 'start' }); }
        }
        on(window, 'hashchange', revealGuide);
        revealGuide();
        function sync() {
          var option = select ? select.selectedOptions[0] : section.querySelector('input[name="id"]');
          if (!option) return;
          section.querySelectorAll('[data-quick-variant]').forEach(function (button) {
            button.setAttribute('aria-pressed', String(button.dataset.quickVariant === option.value));
            var matching = Array.from(select.options).find(function (item) { return item.value === button.dataset.quickVariant; });
            button.disabled = !matching || matching.dataset.available !== 'true';
          });
          if (output) {
            var q = quantity ? Number(quantity.value) : 1;
            var valid = option.dataset.available === 'true' && q > 0 && (!quantity || quantity.validity.valid);
            output.textContent = valid ? money(Number(option.dataset.cents) * q, section) : '—';
            updateBulk(section, Number(option.dataset.cents), q, valid);
          }
        }
        if (select && pills) {
          pills.hidden = false;
          on(pills, 'click', function (event) {
            var button = event.target.closest('[data-quick-variant]');
            if (!button || button.disabled) return;
            var option = Array.from(select.options).find(function (item) { return item.value === button.dataset.quickVariant; });
            if (!option) return;
            option.selected = true;
            select.dispatchEvent(new Event('change', { bubbles: true }));
          });
        }
        if (select) on(select, 'change', sync);
        if (quantity) on(quantity, 'input', sync);
        sync();
      });
    });
    nodes('[data-service-finder]', root).forEach(function (finder) {
      bind(finder, function (on) {
        var select = finder.querySelector('[data-surface-select]');
        function sync() { finder.querySelectorAll('[data-surface-result]').forEach(function (panel) { panel.hidden = panel.dataset.surfaceResult !== select.value; }); }
        on(select, 'change', sync); sync();
      });
    });
    nodes('[data-artwork-calculator]', root).forEach(function (calculator) {
      bind(calculator, function (on) {
        var pixels = calculator.querySelector('[data-pixels]');
        var width = calculator.querySelector('[data-print-width]');
        var unit = calculator.querySelector('[data-print-unit]');
        var previousUnit = unit.value;
        function sync() {
          var px = Number(pixels.value), inputWidth = Number(width.value);
          var inches = unit.value === 'cm' ? inputWidth / 2.54 : inputWidth;
          var valid = pixels.validity.valid && width.validity.valid && px > 0 && inches > 0 && Number.isFinite(px / inches);
          var ppi = calculator.querySelector('[data-ppi]'), target = calculator.querySelector('[data-target]');
          ppi.textContent = valid ? Math.round(px / inches).toLocaleString() + ' PPI' : '—';
          target.textContent = valid ? Number((px / 300 * (unit.value === 'cm' ? 2.54 : 1)).toFixed(2)).toLocaleString() + ' ' + unit.value : '—';
          var status = calculator.querySelector('[data-resolution-status]');
          status.textContent = !valid ? calculator.dataset.invalid : px / inches >= 300 ? calculator.dataset.good : calculator.dataset.low;
          status.dataset.level = !valid ? 'invalid' : px / inches >= 300 ? 'good' : 'low';
        }
        on(pixels, 'input', sync); on(width, 'input', sync);
        on(unit, 'change', function () {
          if (width.value && Number(width.value) > 0 && previousUnit !== unit.value) width.value = String(Number((Number(width.value) * (unit.value === 'cm' ? 2.54 : 1 / 2.54)).toFixed(4)));
          previousUnit = unit.value; sync();
        });
        sync();
      });
    });
    nodes('[data-quote-calculator]', root).forEach(function (calculator) {
      bind(calculator, function (on) {
        var route = calculator.querySelector('[data-quote-route]'), quantity = calculator.querySelector('[data-quote-quantity]');
        var link = calculator.querySelector('[data-quote-link]'), total = calculator.querySelector('[data-quote-total]');
        function sync(resetRules) {
          var selected;
          calculator.querySelectorAll('[data-quote-sizes]').forEach(function (panel) {
            panel.hidden = panel.dataset.quoteSizes !== route.value;
            if (!panel.hidden) selected = panel.querySelector('[data-quote-size]');
          });
          var option = selected && selected.selectedOptions[0];
          if (option && resetRules) {
            quantity.min = option.dataset.min || '1'; quantity.step = option.dataset.step || '1';
            if (option.dataset.max) quantity.max = option.dataset.max; else quantity.removeAttribute('max');
            if (!quantity.validity.valid || Number(quantity.value) <= 0) quantity.value = quantity.min;
          }
          var available = option && option.dataset.available === 'true';
          var valid = available && quantity.validity.valid && Number(quantity.value) > 0;
          total.textContent = valid ? money(Number(option.dataset.cents) * Number(quantity.value), calculator) : '—';
          updateBulk(calculator, option ? Number(option.dataset.cents) : 0, Number(quantity.value), valid);
          link.setAttribute('aria-disabled', String(!valid));
          if (valid) link.href = selected.dataset.productUrl + '?variant=' + encodeURIComponent(option.value) + '&quantity=' + encodeURIComponent(quantity.value);
          else link.removeAttribute('href');
          calculator.querySelector('[data-quote-status]').textContent = available ? '' : calculator.dataset.unavailable;
        }
        on(calculator, 'change', function (event) { sync(event.target !== quantity); });
        on(quantity, 'input', function () { sync(false); });
        on(link, 'click', function (event) { if (link.getAttribute('aria-disabled') === 'true') event.preventDefault(); });
        sync(true);
      });
    });
    nodes('[data-faq-search]', root).forEach(function (section) {
      bind(section, function (on) {
        var input = section.querySelector('[data-faq-query]');
        if (!input) return;
        section.querySelector('[data-faq-search-ui]').hidden = false;
        on(input, 'input', function () {
          var query = input.value.trim().toLocaleLowerCase(), visible = 0;
          section.querySelectorAll('details').forEach(function (row) {
            row.hidden = query !== '' && !row.textContent.toLocaleLowerCase().includes(query);
            if (!row.hidden) visible++;
          });
          section.querySelector('[data-faq-empty]').hidden = visible > 0;
        });
      });
    });
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    nodes('[data-product-section],[data-service-finder],[data-artwork-calculator],[data-quote-calculator],[data-faq-search]', event.target).forEach(function (node) { if (cleanups.has(node)) cleanups.get(node)(); });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }); else init(document);
})();
